import { T as e } from "./export-cdcbfb2b.js";
const t = {}, r = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: t
}, Symbol.toStringTag, { value: "Module" })), a = /* @__PURE__ */ e(r);
export {
  a as r
};
